"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestDictionaryService = exports.GraphQLDictionaryService = exports.DictionaryServiceBase = void 0;
var dictionary_service_1 = require("./dictionary-service");
Object.defineProperty(exports, "DictionaryServiceBase", { enumerable: true, get: function () { return dictionary_service_1.DictionaryServiceBase; } });
var graphql_dictionary_service_1 = require("./graphql-dictionary-service");
Object.defineProperty(exports, "GraphQLDictionaryService", { enumerable: true, get: function () { return graphql_dictionary_service_1.GraphQLDictionaryService; } });
var rest_dictionary_service_1 = require("./rest-dictionary-service");
Object.defineProperty(exports, "RestDictionaryService", { enumerable: true, get: function () { return rest_dictionary_service_1.RestDictionaryService; } });
